"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.formatData = exports.areEqual = void 0;
exports.formatLabel = formatLabel;
exports.radiusPointManipulator = exports.getLines = exports.getIsSingular = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("fast-deep-equal/es6/react"));

var _utils = _interopRequireDefault(require("../../utils"));

var getIsSingular = function getIsSingular(dataset) {
  var _dataset$datasets;

  return (dataset == null ? void 0 : (_dataset$datasets = dataset.datasets) == null ? void 0 : _dataset$datasets.length) <= 1;
};

exports.getIsSingular = getIsSingular;

var areEqual = function areEqual(prevProps, nextProps) {
  return (0, _react["default"])(prevProps, nextProps);
};

exports.areEqual = areEqual;

function formatLabel(str, maxLineWidth) {
  var sections = [];
  var words = str.split(" ");
  words[0] = _utils["default"].titleCaps(words[0]);
  var temp = "";
  words.forEach(function (item, index) {
    if (temp.length > 0) {
      var concat = temp + " " + item;

      if (concat.length > maxLineWidth) {
        sections.push(temp);
        temp = "";
      } else if (index === words.length - 1) {
        sections.push(concat);
        return;
      } else {
        temp = concat;
        return;
      }
    }

    if (index === words.length - 1) {
      sections.push(item);
      return;
    }

    if (item.length < maxLineWidth) {
      temp = item;
    } else {
      sections.push(item);
    }
  });
  return sections;
}

var formatData = function formatData(_ref) {
  var dataset = _ref.dataset,
      forceDataZero = _ref.forceDataZero,
      colorScale = _ref.colorScale;
  var singular = getIsSingular(dataset);

  var getBackgroundColor = function getBackgroundColor(i) {
    if (colorScale) {
      return singular ? colorScale : colorScale[i];
    }

    return null;
  };

  var returnObj = (0, _extends2["default"])({}, dataset, {
    datasets: dataset.datasets.map(function (d, i) {
      return (0, _extends2["default"])({}, d, {
        label: _utils["default"].titleCaps(d.label),
        data: d.data.map(function (v) {
          return forceDataZero ? 0 : v;
        }),
        backgroundColor: getBackgroundColor(i)
      });
    })
  });
  if (dataset.labels) returnObj.labels = dataset.labels.map(function (l) {
    return formatLabel(l, 20);
  });
  return returnObj;
}; // Scales the bubbles up or down depending on width of matrix


exports.formatData = formatData;

var radiusPointManipulator = function radiusPointManipulator(_ref2) {
  var _dataset$datasets2;

  var dataset = _ref2.dataset,
      device = _ref2.device,
      graphWidth = _ref2.graphWidth,
      forceDataZero = _ref2.forceDataZero;
  var largestPoint = dataset == null ? void 0 : (_dataset$datasets2 = dataset.datasets) == null ? void 0 : _dataset$datasets2.map(function (set) {
    return set.data.map(function (d) {
      return d.r;
    });
  }).flat().sort(function (a, b) {
    return b - a;
  })[0];

  var scaler = function () {
    return (graphWidth * (device === "MOBILE" ? 0.03 : 0.05) - largestPoint) / largestPoint;
  }();

  var getRadius = function getRadius(r) {
    if (scaler > 0) {
      return r + r * scaler;
    }

    return r - r * Math.abs(scaler);
  };

  var newDatasets = dataset ? dataset.datasets.map(function (set) {
    return (0, _extends2["default"])({}, set, {
      data: set.data.map(function (d) {
        return (0, _extends2["default"])({}, d, {
          originalR: d.r,
          r: forceDataZero ? 0 : getRadius(d.r)
        });
      })
    });
  }) : dataset;
  return (0, _extends2["default"])({}, dataset, {
    datasets: newDatasets
  });
}; // Splits text into separate lines by max width


exports.radiusPointManipulator = radiusPointManipulator;

var getLines = function getLines(ctx, text, maxWidth) {
  var words = text.split(" ");
  var lines = [];
  var currentLine = words[0];

  for (var i = 1; i < words.length; i += 1) {
    var word = words[i];

    var _ctx$measureText = ctx.measureText(currentLine + " " + word),
        width = _ctx$measureText.width;

    if (width < maxWidth) {
      currentLine += " " + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }

  lines.push(currentLine);
  return lines;
};

exports.getLines = getLines;